import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loginType: localStorage.getItem('loginType2') || 1,
        actives: localStorage.getItem('actives2') || null,
        activeIndex: localStorage.getItem('activeIndex2') || -1,
        lang: localStorage.getItem('lang') || 'zh',
        bannerList: localStorage.getItem('bannerList2') && JSON.parse(localStorage.getItem('bannerList2')) || [],
        userInfo: localStorage.getItem('userInfo2') ? JSON.parse(localStorage.getItem('userInfo2')) : {},
        step: localStorage.getItem('step2') || 0
    },
    getters: {},
    mutations: {

        SETACTIVES(state, index) {
            localStorage.setItem('actives2', index)
            state.actives = index
        },
        SETACTIVE(state, index) {
            localStorage.setItem('activeIndex2', index)
            state.activeIndex = index
        },
        SETLANG(state, lang) {
            state.lang = lang
        },
        SETLOGINTYPE(state, type) {
            localStorage.setItem('loginType2', type)
            state.loginType = type
        },
        SETBANNERLIST(state, bannerList) {
            localStorage.setItem('bannerList2', JSON.stringify(bannerList))
            state.bannerList = bannerList
        },
        SETUSERINFO(state, userInfo) {
            localStorage.setItem('userInfo2', JSON.stringify(userInfo))
            state.userInfo = userInfo

        },
        SETSTEP(state, step) {
            localStorage.setItem('step2', step)
            state.step = step
        }
    },
    actions: {},
    modules: {}
})